import { withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import { styles } from "./AnchorLink.styles";
import { Variant as ThemeVariant } from "@material-ui/core/styles/createTypography";
import { Typography } from "@material-ui/core";

interface IAnchorLinkProps extends WithStyles<typeof styles> {
    to: string;
    variant?: ThemeVariant;
    children?: React.ReactNode;
    newWindow?: boolean;
    className?: any;
    id?: any;
}

const AnchorLinkPure: React.FunctionComponent<IAnchorLinkProps> = ({
                                                                       to,
                                                                       id,
                                                                       children,
                                                                       variant,
                                                                       newWindow,
                                                                       className,
                                                                       classes
                                                                   }: IAnchorLinkProps) => {
    return (
        <Typography variant={variant}>
            <a id={id} href={to} target={newWindow ? "_blank" : ""} className={`${classes.link} ${className}`} rel="noreferrer">
                {children}
            </a>
        </Typography>
    );
};

export const AnchorLink = withStyles(styles)(AnchorLinkPure);
